import * as React from "react";
import Icon from "../../../../components/atoms/Icon";
import styles from "./styles.scss";

interface Props {
  fullName: string;
}

const OperatorFullName: React.FC<Props> = ({ fullName }) => (
  <div className={styles.operatorName}>
    <Icon name="icon-account" className={styles.iconsvg} />
    {fullName}
  </div>
);

export default OperatorFullName;
